import { connect } from 'react-redux';

import { editComment } from './actions';
import Comment from './Comments/Comment';

const CommentContainer = connect(
  (
    { discussion: { usersById, changeRequestsByCommentsId } },
    { model: { id, senderId } },
  ) => ({
    sender: usersById[senderId],
    changeRequest: changeRequestsByCommentsId[id],
    Component: CommentContainer,
  }),
  { onEdit: editComment },
)(Comment);

export default CommentContainer;
